import React from "react";

// Progress table for one audit run. For each of the 7 checks: Yesterday (previous run), Today (change since then), Remaining (still open now).
// Read-only. Lower numbers are better. The change is a net difference between the two runs.
const CHECKS = [["npmApp", "NPM Audit"], ["npmFn", "NPM Functions"], ["semgrep", "Semgrep"], ["openRules", "Open Rules"], ["secrets", "Secrets"], ["outdated", "Outdated"], ["sonar", "Sonar"]];
const isNum = (v) => typeof v === "number";
const th = { padding: "6px 8px", border: "1px solid #2a2e45", textAlign: "center", color: "#8d93ad", fontWeight: 600 };
const td = { padding: "6px 8px", border: "1px solid #23273a", textAlign: "center" };

const today = (y, c) => {
  if (!isNum(y) || !isNum(c)) return <span style={{ color: "#7b82a0" }}>-</span>;
  if (c < y) return <span style={{ color: "#4ade80" }}>{(y - c) + " fixed"}</span>;
  if (c > y) return <span style={{ color: "#f87171" }}>{(c - y) + " new"}</span>;
  return <span style={{ color: "#7b82a0" }}>no change</span>;
};

export default function AuditProgress({ per }) {
  const rows = per || [];
  return (
    <div style={{ margin: "8px 0 12px" }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: "#e8eaf6", marginBottom: 6 }}>
        Progress by check <span style={{ fontWeight: 400, color: "#8d93ad" }}>(Yesterday = previous run, Today = change since then, Remaining = still open now)</span>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ borderCollapse: "collapse", minWidth: 1100, fontSize: 12, color: "#c8cce0" }}>
          <thead>
            <tr>
              <th style={{ ...th, textAlign: "left" }} rowSpan={2}>Project</th>
              {CHECKS.map(([k, l]) => <th key={k} colSpan={3} style={th}>{l}</th>)}
            </tr>
            <tr>
              {CHECKS.map(([k]) => (
                <React.Fragment key={k}>
                  {["Yesterday", "Today", "Remaining"].map((h) => <th key={h} style={{ ...th, fontWeight: 400 }}>{h}</th>)}
                </React.Fragment>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((x) => (
              <tr key={x.p}>
                <td style={{ ...td, textAlign: "left", fontWeight: 600, color: "#e8eaf6" }}>{x.p}</td>
                {CHECKS.map(([k]) => {
                  const y = x.prev ? x.prev[k] : undefined;
                  const c = x.cur ? x.cur[k] : undefined;
                  return (
                    <React.Fragment key={k}>
                      <td style={td}>{isNum(y) ? y : "-"}</td>
                      <td style={td}>{today(y, c)}</td>
                      <td style={{ ...td, color: "#fff", fontWeight: 600 }}>{isNum(c) ? c : "-"}</td>
                    </React.Fragment>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}